import { Box, Icon, Tag, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { PlannedBreakFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import type PlannedBreak from 'modules/time_planning/store/internal/models/PlannedBreak'

import TooltipLabel from './TooltipLabel'

export interface Props {
  // FIXME: Remove PlannedBreak type once we get rid of the model
  // Right now we are supporting both the mobx store model and the GraphQL type.
  plannedBreak: PlannedBreak | PlannedBreakFragment
}

const BreakInformation = ({ plannedBreak }: Props) => {
  const [isTooltipOpen, setIsTooltipOpen] = useToggle(false)

  return (
    <Tag type={plannedBreak.breakConfigurationPaid ? Tag.Types.lime : Tag.Types.malibu}>
      <Tooltip.Alt
        attachment="bottom center"
        open={isTooltipOpen}
        toggle={setIsTooltipOpen}
        label={<TooltipLabel plannedBreak={plannedBreak} timezone="Utc" size="200" />}
      >
        <Box flexDirection="row" gap="s4" alignItems="center">
          <Icon.Small icon="coffee" color="grey1000" />
          <Box alignItems="center" maxWidth="s96">
            <Text.Normal color="grey1000" size="200" weight="medium" ellipsis>
              {plannedBreak?.breakConfigurationName}
            </Text.Normal>
          </Box>
        </Box>
      </Tooltip.Alt>
    </Tag>
  )
}

export default observer(BreakInformation)
